import React from 'react'
import SvgIcons from './SvgIcon'

export default props => (
  <SvgIcons viewBox="0 0 22 22" fill="none" {...props}>
    <path d="M16.5 5.5L5.5 16.5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.5 5.5L16.5 16.5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcons>
)
